import { TextView } from '@dreryk/react-components';
import { dateTimeMinuteFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

const EMPTY_PLACEHOLDER = '-';

type AdvancePaymentDateTextViewProps = Readonly<{ paymentDate: Date | null | undefined }>;

export const AdvancePaymentDateTextView = (props: AdvancePaymentDateTextViewProps): JSX.Element => {
   return (
      <TextView testId={'advancePaymentDate'} label={translationKeys.advancePaymentDate}>
         {props.paymentDate ? dateTimeMinuteFormatter(props.paymentDate) : EMPTY_PLACEHOLDER}
      </TextView>
   );
};
